import React from 'react';

import type { ExtensionParams } from '@atlaskit/editor-common/extensions/extension-handler';
import type { Parameters } from '@atlaskit/editor-common/extensions/extension-parameters';
import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

import { getMacroDimensions, getMacroOptions, getMacroParams } from './TeamCalendarMacroUtils.ts';

const styles = cssMap({
	dimensions: {
		overflow: 'hidden',
	},
	skeleton: {
		width: '100%',
		height: '100%',
		minHeight: 0,
		boxSizing: 'border-box',
		borderRadius: token('radius.small'),
		backgroundColor: token('elevation.surface.sunken'),
	},
});

export const TeamCalendarMacroSsrPlaceholder = ({
	extensionNode,
}: {
	extensionNode?: ExtensionParams<Parameters>;
}): React.JSX.Element => {
	const macroParams = getMacroParams(extensionNode);
	const macroOptions = getMacroOptions(macroParams);
	const macroDimensions = getMacroDimensions(macroParams, macroOptions);

	return (
		<div
			css={styles.dimensions}
			data-testid="calendar-macro-ssr-placeholder"
			style={{
				width: macroDimensions.width,
				height: macroDimensions.height,
			}}
		>
			<div aria-hidden css={styles.skeleton} data-testid="team-calendar-macro-ssr-placeholder" />
		</div>
	);
};
